import { useAccountTypeBrowse } from "@features/tickets/shared/hooks/useAccountTypeBrowse";
import { OUTCOME_ACCOUNT_TYPE } from "./outcomes.constants";

export function useOutcomesBrowse() {
  return useAccountTypeBrowse({
    accountType: OUTCOME_ACCOUNT_TYPE,
  });
}
